import type { Party, PartyLedgerEntry } from '@coreledger/shared-types';
import { api } from './client';
import type { PaginationMeta } from './invoices';

export type { PaginationMeta };
export interface Paginated<T> { data: T[]; meta: PaginationMeta }

export interface PartyLedgerResponse {
  party: { id: string; name: string };
  entries: PartyLedgerEntry[];
  summary: { totalDebit: number; totalCredit: number; balance: number };
}

export const partiesApi = {
  list: (search?: string, page = 1, limit = 50, type?: string) => {
    const p = new URLSearchParams();
    if (search) p.set('search', search);
    if (type) p.set('type', type);
    p.set('page', String(page));
    p.set('limit', String(limit));
    return api.get<Paginated<Party>>(`/parties?${p.toString()}`);
  },
  get: (id: string) => api.get<Party>(`/parties/${id}`),
  create: (data: Partial<Party>) => api.post<Party>('/parties', data),
  update: (id: string, data: Partial<Party>) => api.patch<Party>(`/parties/${id}`, data),
  delete: (id: string) => api.delete<void>(`/parties/${id}`),
  bulkDelete: (ids: string[]) => api.patch<{ deleted: number }>('/parties/bulk-delete', { ids }),
  deleteAll: () => api.patch<{ deleted: number }>('/parties/delete-all', {}),
  ledger: (id: string) => api.get<PartyLedgerResponse>(`/parties/${id}/ledger`),
  ledgerByName: (name: string) => api.get<PartyLedgerResponse>(`/parties/ledger-by-name?name=${encodeURIComponent(name)}`),
};
